import * as React from 'react';

import { FOfferType, FDealType } from '../../../../utils/category';
import { SearchButtonContainer } from '../../search_button/container';
import { SaveSearchButton } from './components/SaveSearchButton';
import { ClearFiltersButton } from './components/ClearFiltersButton';
import { IParam } from './params/types';
import { IParams } from './params';
import { EasterEggCar } from './EasterEggCar';
import * as styles from './advancedFilters.css';

interface IAdvancedFiltersProps {
  offerType: FOfferType;
  dealType: FDealType;
  params: [keyof IParams, IParam][];
  // tslint:disable-next-line:no-any
  onSearchButtonClick(): any;
}

export class AdvancedFilters extends React.Component<IAdvancedFiltersProps> {
  public render() {
    return (
      <div className={styles['advanced-filters']}>
        <div className={styles['table']}>
          {this.props.params.map(([key, { title, component: Component, disabled }]) => {
            if (disabled) {
              return null;
            }

            return (
              <div key={key} className={styles['row']}>
                <div className={styles['cell']}>{title}</div>
                <div className={styles['cell']}>
                  <div className={styles['content']}>
                    <Component offerType={this.props.offerType} dealType={this.props.dealType} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles['buttons']}>
          <SearchButtonContainer
            onClick={this.handleClickSearchButton}
            buttonStyle={styles['button']}
            isNewAdvancedFilters
          />
          <SaveSearchButton />
          <ClearFiltersButton />
        </div>
        <EasterEggCar />
      </div>
    );
  }

  private handleClickSearchButton = () => {
    this.props.onSearchButtonClick();
  };
}
